import { Events } from '@/utils/servicesEvents'
import { Network } from '@/utils/network'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getCategories(onSuccessEvent, onErrorEvent) {
  const response = await sendRequest()
  const parsedResponse = parseResponse(response, Formatter)
  const event = parsedResponse.statusCode == 200 ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(event, parsedResponse)
}

async function sendRequest() {
  const url = urls.getCategories
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  if (
    response &&
    response.status.code === 200 &&
    response?.response?.statusCode == 200
  ) {
    const rawData = response.response.data
    const appData = Formatter.parseExternalCategories(rawData)

    return {
      statusCode: 200,
      data: appData,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getCategories }
